import { EmptyFeed } from '@elements/EmptyState'
import styled from '@emotion/styled'
import { CircularProgress } from '@mui/material'

const ProgressContainer = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
  align-items: center;
  padding-top: 10rem;
`

const FeedEmptyPlaceholder = ({ context }) => {
  const { currentTab, postsEmpty, postsLoaded } = context
  // TODO: When we refactor this into its own component, we'll probably want to add a delay
  //       So it only renders after a certain number of milliseconds
  if (currentTab == 2 && !postsLoaded) {
    return (
      <ProgressContainer>
        <CircularProgress
          style={{ color: '#6A23FF' }}
          thickness={8}
        />
      </ProgressContainer>
    )
  } else if (currentTab && postsEmpty) {
    return (
      <EmptyFeed />
    )
  }
}

export { FeedEmptyPlaceholder }
